"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookItemConverterImpl_1 = require("../../core/model/codebook/conversions/CodebookItemConverterImpl");

var PromoDistributionModel_1 = require("../model/PromoDistributionModel");

var PromoDistributionModelConverter_1 = require("./PromoDistributionModelConverter");
/**
 * Default implementation of PromoDistributionModelConverterImpl.
 *
 * @author ZSr
 */


var PromoDistributionModelConverterImpl =
/*#__PURE__*/
function (_PromoDistributionMod) {
  _inherits(PromoDistributionModelConverterImpl, _PromoDistributionMod);

  function PromoDistributionModelConverterImpl() {
    var _this;

    _classCallCheck(this, PromoDistributionModelConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoDistributionModelConverterImpl).call(this));
    _this.codebookItemConverter = new CodebookItemConverterImpl_1.CodebookItemConverterImpl();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PromoDistributionModelConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PromoDistributionModel_1.PromoDistributionModel(PromoDistributionModel_1.PromoDistributionModel.distSchema.id.valueOf(conversions.documentToClassId(source)), PromoDistributionModel_1.PromoDistributionModel.distSchema.title.valueOfField(source), PromoDistributionModel_1.PromoDistributionModel.distSchema.description.valueOfField(source), PromoDistributionModel_1.PromoDistributionModel.distSchema.flags.valueOfField(source), PromoDistributionModel_1.PromoDistributionModel.distSchema.externalId.valueOfField(source), source.classification);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = this.codebookItemConverter.toDocument(source, conversions);
      Object.assign(document, {
        classification: source.classification
      });
      return document;
    }
  }]);

  return PromoDistributionModelConverterImpl;
}(PromoDistributionModelConverter_1.PromoDistributionModelConverter);

exports.PromoDistributionModelConverterImpl = PromoDistributionModelConverterImpl;